import { NavStyle } from './shared.style';
import * as RadixPopover from '@radix-ui/react-popover';
import styled from 'styled-components';

export const TriggerButton = styled(RadixPopover.Trigger)`
  border-width: 0;
  background: transparent;

  &[data-state='open'] {
    color: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};

    svg {
      fill: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
    }
  }

  ${NavStyle}
`;

export const Content = styled(RadixPopover.Content)`
  z-index: 1000;
  background-color: white;
  border-style: solid;
  border-width: 1px;
  border-color: #e0ebed;
  border-radius: 0.5rem;
  overflow: hidden;
  max-width: 95vw;

  &::after {
    content: '';
    position: absolute;
    bottom: -0.7rem;
    right: -0.7rem;
    width: 100%;
    height: 100%;
    background: rgba(215, 229, 231, 0.8);
    backdrop-filter: blur(2px);
    z-index: -1;
    border-radius: 0.5rem;
  }
`;

export const PopoverArrow = styled(RadixPopover.Arrow)`
  width: 25px;
  height: 12px;
  margin-top: -1px;
  fill: white;
  clip-path: inset(0 -10px -10px -10px);
  stroke: #e0ebed;
  stroke-width: 1px;

  polygon {
    stroke-dasharray: 0 28 25;
  }
`;
